/** Ce qu'une colonne de l'e-mail peut porter. */
export enum EMAIL_BLOCK_TYPE {
    IMAGE = 'IMAGE',
    TEXT = 'TEXT',
    BUTTON = 'BUTTON',
    SPACER = 'SPACER',
    DIVIDER = 'DIVIDER',
    SOCIALS = 'SOCIALS',
    /**
     * Lien de désabonnement, imposé par la loi : il n'est ni ajouté ni retiré depuis la palette,
     * le gabarit le pose et l'éditeur le laisse en place.
     */
    UNSUBSCRIBE_LINK = 'UNSUBSCRIBE_LINK',
}
